import { render, staticRenderFns } from "./planlistParticulars.vue?vue&type=template&id=2e195610&scoped=true&"
import script from "./planlistParticulars.vue?vue&type=script&lang=js&"
export * from "./planlistParticulars.vue?vue&type=script&lang=js&"
import style0 from "./planlistParticulars.vue?vue&type=style&index=0&id=2e195610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e195610",
  null
  
)

export default component.exports